import { render } from "./BasicLayout.vue?vue&type=template&id=2b30d8fe&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=2b30d8fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b30d8fe"

export default script